import * as React from 'react';
import { AccountViewModel } from '@models/Account';
import { HostedCheckout } from '../../../payment/_components/gateway/hosted-checkout-container';
import { PaymentMethods } from '../../../_models/HostedCheckoutTransactionViewModel';
import Constants from 'src/_constants/Constants';
import { PaymentTerms, PaymentType } from '../../../_models/Payment';
import { PaymentPurpose } from '@models/Payment';

export interface CreditCardListComponentProperties {
  accountId: number;
  accountType: number;
  creditCard: AccountViewModel;
  readonly withHostedCheckout?: boolean;
  resetCreditCardList: () => void;
  getAccount: (id: number) => void;
  openCreditCardModal: (
    accountId: number,
    accountType: number,
    creditCard?: AccountViewModel,
    hostedCheckoutButton?: HTMLButtonElement | null
  ) => void;
  openDeleteModal: (creditCard: AccountViewModel) => void;
}

export class CreditCardListComponent extends React.Component<CreditCardListComponentProperties> {
  launchButton: HTMLButtonElement | null = null;
  componentWillUnmount() {
    this.props.resetCreditCardList();
  }

  render() {
    return (
      <div className="row">
        <>
          <HostedCheckout
            accountId={this.props.accountId}
            getHiddenFormButton={b => (this.launchButton = b)}
            paymentMethod={PaymentMethods.CreditCard}
            installmentsFee={Constants.Payments.INSTALLMENT_SERVICE_FEE}
            paymentAmountInitial={0}
            paymentAmountBalance={0}
            paymentTerms={PaymentTerms.OneInstallment}
            paymentTypeInitial={PaymentType.CreditCard}
            paymentTypeBalance={PaymentType.CreditCard}
            paymentPurpose={PaymentPurpose.PreAuthorization}
            remainingBalance={0}
            remainingBalanceDueString="0"
          />
        </>
        <div className="col-md-12">
          <label>
            Credit Card on File
            {this.props.creditCard && Object.keys(this.props.creditCard).length ? (
              ''
            ) : (
              <span
                className="ml-10 pl-10 red-text pointer"
                onClick={() =>
                  this.props.openCreditCardModal(
                    this.props.accountId,
                    this.props.accountType,
                    undefined,
                    this.launchButton
                  )
                }
              >
                Add
              </span>
            )}
          </label>
          {this.props.creditCard && Object.keys(this.props.creditCard).length ? (
            <h3 key={this.props.creditCard.creditCardToken}>
              {this.props.creditCard.creditCardType} xxxxxxxx
              {this.props.creditCard.creditCardLastFour}
              <i
                className="fas fa-edit ml-5 red-text pointer"
                onClick={() =>
                  this.props.openCreditCardModal(
                    this.props.accountId,
                    this.props.accountType,
                    this.props.creditCard,
                    this.launchButton
                  )
                }
              />
              <i
                className="fas fa-times ml-5 red-text pointer"
                onClick={() => this.props.openDeleteModal(this.props.creditCard)}
              />
            </h3>
          ) : (
            <h3>--</h3>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/credit-cards/credit-card-list.component.tsx